import { FC } from 'react';
import './styles.css';

export const RectangleUp: FC = () => (
	<span className="rectangle-up--container">
		<span className="rectangle-up" />
	</span>
);
